import React from 'react';

import ClubSponsorLogo from '../ClubSponsorLogo';
import Organizers from '../Organizers';
import TeamRoles from '../../../TeamRoles/ClubProfile/teamRolesDisplay';
import AdultTeamTennisRoles from '../AdultTeamTennisRoles/adultTeamTennisRoles';
import { showPrivateClubData, hasSchoolLinked, isClubAdminOrOwner, isTeamTennisClub } from '../../../../utils/clubs';

const SidePanelTopSection = (props) => {
    const {
        auth,
        clubType,
        clubDetails,
        handleUploadPhoto,
        handleUploadLogoStart,
        removeSponsorLogo,
        sendMessage,
    } = props;

    const { tierType } = clubDetails;
    const isAdultTeamTennisClub = isTeamTennisClub(tierType);
    return (
        <React.Fragment>
            <ClubSponsorLogo
                clubDetails={clubDetails}
                handleUploadPhoto={handleUploadPhoto}
                handleUploadLogoStart={handleUploadLogoStart}
                removeSponsorLogo={removeSponsorLogo}
                user={auth.user}
            />

            {isAdultTeamTennisClub && (
                <AdultTeamTennisRoles
                    clubDetails={clubDetails}
                    isAdminOrOwner={isClubAdminOrOwner(clubDetails)}
                    typeOfTeamRolesName={'Captains'}
                    clubType={clubType}
                    auth={auth}
                    sendMessage={sendMessage}
                />
            )}
            {showPrivateClubData(clubDetails) && hasSchoolLinked(clubDetails) &&
                clubDetails.teamRoles && (
                <TeamRoles
                    clubDetails={clubDetails}
                    isAdminOrOwner={isClubAdminOrOwner(clubDetails)}
                    typeOfTeamRolesName={'Coaches'}
                    clubType={clubType}
                    auth={auth}
                    sendMessage={sendMessage}
                />
            )}
            {!isAdultTeamTennisClub && !hasSchoolLinked(clubDetails) && (
                <Organizers
                    clubDetails={clubDetails}
                    auth={auth}
                    clubType={clubType}
                    sendMessage={sendMessage}
                />
            )}

        </React.Fragment>
    );
};

export default SidePanelTopSection;
